import { GAME_BUILD_STATUS } from '@crazygames/game-types/src/game-build/game-build-status.type';
import { COLORS } from '../../common/Styleguide/Common/colors';

export const getGameBuildStatusColor = (status: GAME_BUILD_STATUS) => {
  switch (status) {
    case 'SUBMITTED':
      return COLORS.white[100];
    case 'ACTIVE':
      return COLORS.success[100];
    case 'ACCEPTED':
      return COLORS.white[20];
    case 'DRAFT':
    default:
      return COLORS.white[60];
  }
};

export const getGameBuildStatusReadable = (status: GAME_BUILD_STATUS) => {
  switch (status) {
    case 'DRAFT':
      return 'Draft';
    case 'SUBMITTED':
      return 'Submitted';
    case 'ACTIVE':
      return 'Active';
    case 'ACCEPTED':
      return 'Accepted';
    case 'REJECTED':
      return 'Rejected';
    default:
      return 'Unknown';
  }
};

export const getBuildTooltip = (status: string) => {
  switch (status) {
    case 'DRAFT':
      return `This build has yet to go through QA and be submitted. Only the latest draft build can be submitted.`;
    case 'SUBMITTED':
      return 'The build passed the QA and was submitted. It is currently under review.';
    case 'ACTIVE':
      return 'The build is currently live on CrazyGames.';
    case 'ACCEPTED':
      return 'The build was active in the past.';
    case 'REJECTED':
      return 'The build was not accepted by the content team.';
    default:
      return '';
  }
};
